<template>
  <div v-if="location">
    <transition name="fade">
      <div v-if="loading" class="h-full w-full absolute inset-0 flex items-center justify-center z-20 bg-white bg-opacity-50 dark:bg-gray-800/80 backdrop-blur rounded-lg">
        <div class="clock-loader mx-auto" />
      </div>
    </transition>

    <div class="mt-8">
      <nuxt-child :location="location" :loading.sync="loading" />
    </div>

    <div class="hidden text-xs p-4 bg-gray-100 border rounded-xl mt-20">
      {{ auth }}
    </div>
  </div>
</template>

<script>
export default {
  layout: 'auth',
  middleware ({ $auth, redirect }) {
    if (!$auth.location) {
      redirect('/auth/find/domain')
    }
  },
  props: {
    location: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    auth: {
      get () {
        return this.$store.state.auth.auth
      },
      set (value) {
        this.$store.commit('auth/setAuth', value)
      }
    }
  }
}
</script>

<style lang="scss">
.clock-loader {
  --clock-color: #2c384c;
  --clock-width: 6rem;
  --clock-radius: calc(var(--clock-width) / 2);
  --clock-minute-length: calc(var(--clock-width) * 0.4);
  --clock-hour-length: calc(var(--clock-width) * 0.2);
  --clock-thickness: 0.4rem;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--clock-width);
  height: var(--clock-width);
  border: 6px solid var(--clock-color);
  border-radius: 50%;
  filter: drop-shadow(0 0 0.25rem rgba(0,0,0,0.1));

  &::before,
  &::after {
    position: absolute;
    content: "";
    top: calc(var(--clock-radius) * 0.25);
    width: var(--clock-thickness);
    background: var(--clock-color);
    border-radius: 10px;
    transform-origin: center calc(100% - calc(var(--clock-thickness) / 2));
    animation: spin infinite linear;
  }

  &::before {
    height: var(--clock-minute-length);
    animation-duration: 2s;
  }

  &::after {
    top: calc(var(--clock-radius) * 0.25 + var(--clock-hour-length));
    height: var(--clock-hour-length);
    animation-duration: 15s;
  }
}

@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}
</style>
